import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "../../supabase-client";
// import { hashPassword } from "../../utils/hashPassword"; // Use the utility here
import { comparePassword } from "../../utils/hashPassword"; // Import the utility
import { Eye, EyeOff, Mail, Lock } from "lucide-react";

const Login = () => {
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [showPassword, setShowPassword] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [success, setSuccess] = useState("");
   const [error, setError] = useState("");
   const navigate = useNavigate();

   // Check if user is already logged in
   useEffect(() => {
      const checkAuth = async () => {
         const {
            data: { session },
         } = await supabase.auth.getSession();
         if (session) {
            navigate("/"); // Redirect to home if already logged in
         }
      };
      checkAuth();
      setSuccess("");
   }, [navigate]);

   const handleLogin = async (e) => {
      e.preventDefault();

      try {
         const { data: users, error: fetchError } = await supabase
            .from("usuarios") // Assuming you have an admin_users table
            .select("*")
            .eq("email", email)
            .single();

         if (fetchError || !users) {
            setError("Usuario no encontrado");
            setIsLoading(false);
            return;
         }
         console.log("users: ", users);

         if (!email || !password) {
            setError("Por favor completa todos los campos");
            return;
         }

         setIsLoading(true);
         setError("");

         // Compare password with hashed password
         const isValidPassword = await comparePassword(
            password,
            users.password_hash
         );

         if (isValidPassword) {
            // Authentication successful
            // localStorage.setItem("authjwt", users.id);
            localStorage.setItem("authjwt", users.password_hash);

            window.dispatchEvent(new Event("authUpdated"));

            const redirectTo =
               localStorage.getItem("redirectAfterLogin") || "/";
            localStorage.removeItem("redirectAfterLogin");
            navigate(redirectTo);
         } else {
            setError("Contraseña incorrecta");
         }


      } catch (error) {
         console.error("Login error:", error);

         // Handle specific error messages
         switch (error.message) {
            case "Invalid login credentials":
               setError("Email o contraseña incorrectos");
               break;
            case "Email not confirmed":
               setError("Por favor confirma tu email antes de iniciar sesión");
               break;
            case "Too many requests":
               setError(
                  "Demasiados intentos. Intenta nuevamente en unos minutos"
               );
               break;
            default:
               setError(error.message || "Error al iniciar sesión");
         }
      } finally {
         setIsLoading(false);
      }
   };

   const handleForgotPassword = async () => {
      if (!email) {
         setError("Por favor ingresa tu email para recuperar la contraseña");
         return;
      }

      try {

         
         const resp = await fetch(
            "https://coympvieahjboblypoft.supabase.co/functions/v1/mail-register",
            {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
               },
               body: JSON.stringify({
                  aquien: email, // Mail Adminstrador
                  asunto: "Recuperacion de Clave",
                  mensaje: `<p>Para recuperar su clave ingrese <a href="${window.location.origin}/reset-password">aqui</a>.</p>`,
               }),
            }
         );

         if (!resp.ok) {
            throw new Error("Error enviando email");
         }

         setSuccess("Se ha enviado un enlace de recuperación a tu email");
      } catch (error) {
         setError("Error enviando el email de recuperación: " + error.message);
      }
   };

   return (
      <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center px-4 py-16">
         <div className="w-full max-w-sm">
            {/* Header */}
            <div className="text-center mb-10">
               <h1
                  className="text-[3rem] font-medium text-[#1A1A1A] mb-1"
                  style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
               >
                  Bienvenido
               </h1>
               <p className="text-[0.68rem] uppercase tracking-[0.2em] text-[#7A7570]">Diego Curutchet — Galería</p>
               <div className="w-8 h-[1px] bg-[#9B6D3F] mx-auto mt-5" />
            </div>

            {/* Alerts */}
            {error && (
               <div className="mb-6 px-4 py-3 bg-red-50 border-l-2 border-red-500 text-sm text-red-700">
                  {error}
               </div>
            )}
            {success && (
               <div className="mb-6 px-4 py-3 bg-emerald-50 border-l-2 border-emerald-500 text-sm text-emerald-700">
                  {success}
               </div>
            )}

            {/* Form */}
            <form onSubmit={handleLogin} className="space-y-7">
               {/* Email */}
               <div>
                  <label htmlFor="email" className="block text-[0.68rem] uppercase tracking-[0.15em] text-[#7A7570] mb-2">
                     CORREO
                  </label>
                  <div className="relative">
                     <Mail className="absolute left-0 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9B6D3F]" />
                     <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full pl-6 pb-2 bg-transparent border-b border-[#EDE9E4] focus:border-[#9B6D3F] outline-none text-sm text-[#1A1A1A] transition-colors duration-200 placeholder-[#C5C0BB]"
                        placeholder="tu@email.com"
                     />
                  </div>
               </div>

               {/* Password */}
               <div>
                  <label htmlFor="password" className="block text-[0.68rem] uppercase tracking-[0.15em] text-[#7A7570] mb-2">
                     Contraseña
                  </label>
                  <div className="relative">
                     <Lock className="absolute left-0 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9B6D3F]" />
                     <input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full pl-6 pr-7 pb-2 bg-transparent border-b border-[#EDE9E4] focus:border-[#9B6D3F] outline-none text-sm text-[#1A1A1A] transition-colors duration-200 placeholder-[#C5C0BB]"
                        placeholder="••••••••"
                     />
                     <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-0 top-1/2 -translate-y-1/2 text-[#9B6D3F] hover:text-[#6B4A2A] transition-colors"
                     >
                        {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                     </button>
                  </div>
               </div>

               {/* Forgot password */}
               <div className="text-right -mt-3">
                  <button
                     type="button"
                     onClick={handleForgotPassword}
                     className="text-[0.7rem] uppercase tracking-[0.1em] text-[#9B6D3F] hover:text-[#6B4A2A] transition-colors underline underline-offset-2"
                  >
                     ¿Olvidaste tu contraseña?
                  </button>
               </div>

               {/* Submit */}
               <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-3.5 bg-[#9B6D3F] text-white text-[0.72rem] uppercase tracking-[0.18em] hover:bg-[#6B4A2A] transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
               >
                  {isLoading ? (
                     <>
                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        Ingresando...
                     </>
                  ) : (
                     "Ingresar"
                  )}
               </button>
            </form>

            {/* Register link */}
            <div className="mt-8 text-center border-t border-[#EDE9E4] pt-6">
               <p className="text-sm text-[#7A7570]">
                  ¿Primera vez?{" "}
                  <Link to="/register" className="text-[#9B6D3F] hover:text-[#6B4A2A] transition-colors underline underline-offset-2">
                     Crear cuenta
                  </Link>
               </p>
            </div>
         </div>
      </div>
   );
};

export default Login;
